import { HERO_CLASSES } from '@somnhold/content';
import { idiv, imax, mulBp } from '../math/fixed.ts';
import { heroStats, type HeroInit } from './create.ts';

/**
 * The one currency of the paths and the legacies (docs/SENDAS.md, «Calibración»): D is what the reference hero (the
 * mean of the eight classes, with this init's level and gear) deals a second with its basic attack, V its life. A
 * nightmare's life goes in seconds of D, a blow in a share of V.
 */
export const reference = (init: HeroInit): { d: number; v: number } => {
  let d = 0;
  let v = 0;
  for (const cls of HERO_CLASSES) {
    const st = heroStats({ ...init, cls, powerBp: 10000 });
    d += idiv(st.attack * 12 * 100, st.reload);
    v += st.maxHp;
  }
  return { d: idiv(d, HERO_CLASSES.length * 100), v: idiv(v, HERO_CLASSES.length) };
};

/** A life of `seconds` of D (at least 1). */
export const lifeInD = (ref: { d: number }, seconds: number): number => imax(1, ref.d * seconds);

/** A blow of `bp` of V (at least 1). */
export const blowInV = (ref: { v: number }, bp: number): number => imax(1, mulBp(ref.v, bp));
